import PropTypes from 'prop-types';
import { memo } from 'react';
// -*- mode: jsx;-*-
import { DropdownMenu } from '../common/DropdownMenu.js';

let TabSelector = function (props) {
    const challenge = props.challenge;
    const fundedOrCompletedProjects = props.isPartnerPage ? 'Completed projects' : 'Funded projects';
    const options = [
        { value: 'ACTIVE', hidden: false, name: 'Project requests' },
        { value: 'HISTORICAL', hidden: false, name: fundedOrCompletedProjects },
        { value: 'UPDATES', hidden: false, name: 'Supporters' },
    ];

    /**
     * This hackily submits a form so that the request is a POST.
     * It would be nicer to make this AJAX, but that would require changing the server-side response.
     * @param value The new default landing tab
     */
    const handleSelect = function (value) {
        $('.js-landing-tab').val(value);
        $('.js-change-tab').submit();
    };

    // TODO: Remove "HOME" from the DB?
    const selected = challenge.landingTab === 'HOME' ? 'ACTIVE' : challenge.landingTab;

    return (
        <div>
            <DropdownMenu label="Default tab:" options={options} select={handleSelect}
                mainClass="collapsible-tab js-admin" optionsClass="dropdown-options"
                selectedValue={selected} ariaLabel="List of default giving page tab options" />
            <form action={`${secureBaseURL}donors/editChallenge.html`} method="post" className="js-change-tab">
                <input name="action" value="changeLandingTab" hidden="true" />
                <input name="id" value={challenge.id} hidden="true" />
                <input className="js-landing-tab" name="landingTab" hidden="true" />
            </form>
        </div>
    );
};
TabSelector.propTypes = {
    challenge: PropTypes.object.isRequired,
    isPartnerPage: PropTypes.bool,
};
TabSelector = memo(TabSelector);
export default TabSelector;
